import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { patchDateToJson } from './app/shared/globals/date-to-json';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

patchDateToJson();

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    const loader = document.getElementById('loading-bar');
    const text = document.getElementById('loading-text');
    if (loader) {
      loader.remove();
      text?.remove();
    }
  })
  .catch((err) => console.error(err));